import { render, staticRenderFns } from "./TmsTextEditorNew.vue?vue&type=template&id=5c460666&"
import script from "./TmsTextEditorNew.vue?vue&type=script&lang=js&"
export * from "./TmsTextEditorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports